import { render, staticRenderFns } from "./announcementDetail.vue?vue&type=template&id=59efb339&scoped=true"
import script from "./announcementDetail.vue?vue&type=script&lang=js"
export * from "./announcementDetail.vue?vue&type=script&lang=js"
import style0 from "./announcementDetail.vue?vue&type=style&index=0&id=59efb339&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59efb339",
  null
  
)

export default component.exports